import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, QueryList, ViewChildren } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Link } from '@app/core/models/atomics.model';
import { ForgotPasswordService } from '@b2b/features/forgot-password-dialog/core/forgot-password.service';
import { LoginService } from '@b2b/features/login/services/login.service';
import { B2BUnitService } from '@b2b/features/b2b-unit/core/b2b-unit.service';
import { MenuMobileService } from '@core/services/menu-mobile.service';

@Component({
  selector: 'abstract-lines',
  imports: [CommonModule, RouterModule],
  templateUrl: './abstract-lines.component.html',
  styleUrl: './abstract-lines.component.scss',
})
export class AbstractLinesComponent {
  @Input() menu!: Link[];

  @ViewChildren('btnFirstLevel') firstLevelButtons!: QueryList<ElementRef<HTMLButtonElement>>;
  @ViewChildren('btnClose') closeButtons!: QueryList<ElementRef<HTMLButtonElement>>;
  @ViewChildren('btnToggleChildren') toggleChildrenButtons!: QueryList<ElementRef<HTMLButtonElement>>;

  constructor(
    private elRef: ElementRef<HTMLElement>,
    private router: Router,
    private menuMobileService: MenuMobileService,
    private b2bUnitService: B2BUnitService,
    private forgotPasswordService: ForgotPasswordService,
    private loginService: LoginService,
  ) {}

  open(menu: Link): void {
    const index = this.menu.findIndex(item => item.uid === menu.uid);
    const firstLevelButtons = this.firstLevelButtons.toArray();
    const btn = firstLevelButtons[index]?.nativeElement;
    const container = btn?.closest('.js-container')?.querySelector('.js-level');

    if (container) {
      container.classList.toggle('is-active');
    } else {
      if (menu.url && menu.url !== '#') {
        this.router.navigateByUrl(menu.url || '');
      } else {
        switch (menu.uid) {
          case 'topmenu-change-b2b-unit':
            this.b2bUnitService.showSelectionModal();
            break;

          case 'topmenu-b2b-unit-data':
            this.b2bUnitService.showSelectionModal();
            break;

          case 'profile-change-password':
            this.forgotPasswordService.openModal();
            break;
          case 'profile-logout':
            this.loginService.logout();
            break;
        }
      }
      this.menuMobileService.toggleStatus();
      this.close();
    }
  }

  close(): void {
    this.elRef.nativeElement.querySelectorAll('.is-active').forEach((el: Element) => {
      el.classList.remove('is-active');
    });
  }

  toggleChildren(child: Link): void {
    const index = this.menu.flatMap(item => item.children ?? []).findIndex(item => item.uid === child.uid);
    if (index != -1) {
      const toggleChildrenButtons = this.toggleChildrenButtons.toArray();
      const btn = toggleChildrenButtons[index]?.nativeElement;
      const container = btn.closest('.js-container');

      if (container) {
        container.classList.toggle('is-active');
      }
    }
  }
}
